// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

//////////////////////// Footer menu //////////////////////
const footerMenuItems = document.querySelectorAll('.footer__menu__link')
footerMenuItems.forEach((item) => {
    item.addEventListener('mouseenter',function(){
        item.classList.remove('active');
        footerMenuItems.forEach((item) => {
            item.classList.add('active');
        })
    })
    item.addEventListener('mouseleave',function(){
        item.classList.remove('active');
        footerMenuItems.forEach((item) => {
            item.classList.remove('active');
        })
    })
})


//////////////////////// Breadcrumb menu //////////////////////
const breadCrumbItems = document.querySelectorAll('.breadcrumb--link')
breadCrumbItems.forEach((item) => {
    item.addEventListener('mouseenter',function(){
        item.classList.remove('active');
        breadCrumbItems.forEach((item) => {
            item.classList.add('active');
        })
    })
    item.addEventListener('mouseleave',function(){
        item.classList.remove('active');
        breadCrumbItems.forEach((item) => {
            item.classList.remove('active');
        })
    })
})

//////////////////////// Action Post menu //////////////////////
if(window.innerWidth > 640) {
    const actionPostItems = document.querySelectorAll('.action-post--btn')
    actionPostItems.forEach((item) => {
        item.addEventListener('mouseenter',function(){
            item.classList.remove('active');
            actionPostItems.forEach((item) => {
                item.classList.add('active');
            })
        })
        item.addEventListener('mouseleave',function(){
            item.classList.remove('active');
            actionPostItems.forEach((item) => {
                item.classList.remove('active');
            })
        })
    })
}